import(/* webpackChunkName: "contentStage" */ '../../Styles/ContentStage/contentStage.scss');
import(/* webpackChunkName: "paginationSlickSlider" */ 'Feature/Common/code/Pagination/Styles/paginationSlickSlider.scss');

window.am = window.am || {};

window.am.contentStage = new function () {
    var that = this;
    const minHeight = 400;

    that.setEqualContent = function (stage) {
        const hasImageCaption = that.hasImageCaption(stage);
        const captionHeight = that.setEqualCaptionHeight(stage);
        const textboxHeight = that.setEqualTextboxHeight(stage);
        const containerHeight = textboxHeight > minHeight ? textboxHeight : minHeight;
        const imageHeight = that.setEqualImageHeight(stage, textboxHeight);

        if ($(window).width() > 767) {
            if ($(stage).find(".content-stage-img").find(".no-image-position").length > 0) {
                $(stage).find(".content-stage-img img").removeClass("no-image-position");
                $(stage).find(".content-stage-img img").addClass("image-position");
            }

            $(stage).find(".slick-list").css('minHeight', containerHeight + captionHeight + "px");
            $(stage).find(".slick-list").css('maxHeight', containerHeight + "px");
            $(stage).find(".content-stage-element").css('height', containerHeight + captionHeight + "px");
            $(stage).find(".content-stage-content-container ").css('height', '');
            $(stage).find(".content-stage-content").css('top', '');

            if (captionHeight > 0) {
                $(stage).find(".pagination").css('bottom', $(stage).find(".pagination").outerHeight() + captionHeight + "px");
            }

            const imageContainers = $(stage).find('.content-stage-img');

            imageContainers.each(function (i, imageContainer) {
                const imageWithPositioning = $(imageContainer).find('.image-position');

                if (imageWithPositioning.length > 0) {
                    const imageCaption = $(imageContainer).find('.image-caption');
                    imageCaption.css('top', containerHeight + "px");
                }
            });

            if (hasImageCaption) {
                $(stage).find("hr").css('top', containerHeight + "px");
            }
        }
        else {
            if ($(stage).find(".content-stage-img").find(".image-position").length > 0) {
                $(stage).find(".content-stage-img img").removeClass("image-position");
                $(stage).find(".content-stage-img img").addClass("no-image-position");
            }

            $(stage).find(".slick-list").css('minHeight', imageHeight + textboxHeight + (captionHeight > 0 ? captionHeight - 16 : 0) + "px");
            $(stage).find(".slick-list").css('maxHeight', imageHeight + textboxHeight + captionHeight + "px");
            $(stage).find(".content-stage-element").css('height', '');
            $(stage).find("img").css('height', imageHeight + "px");
            $(stage).find(".content-stage-content-container ").css('height', textboxHeight + (captionHeight > 0 ? captionHeight - 16 : 0) + "px");
            $(stage).find(".pagination").css('bottom', '');

            if (hasImageCaption) {
                const imageCaption = $(stage).find('.image-caption');
                imageCaption.css('top', "");

                $(stage).find(".content-stage-content").css('top', captionHeight - 16 + "px");
            }
        }
    }

    that.setEqualTextboxHeight = function (stage) {
        const textboxes = $(stage).find('.content-stage-element .content-stage-content');
        var highestTextBox = 0;

        $(textboxes).css('height', 'auto');

        $(textboxes).each(function (i, textbox) {
            if (highestTextBox < $(textbox).outerHeight()) {
                highestTextBox = $(textbox).outerHeight();
            }
        });

        $(textboxes).css('height', highestTextBox + 'px');

        return highestTextBox + ($(window).width() > 767 ? 112 : 80);
    }

    that.setEqualImageHeight = function (stage, textboxHeight) {
        const imageContainers = $(stage).find(".content-stage-img");
        $(imageContainers).find('img').css('height', "");

        let imageHeight = 0;

        $(imageContainers).each(function (i, container) {
            if (imageHeight < $(container).outerHeight()) {
                imageHeight = $(container).outerHeight();
            }
        });

        if (textboxHeight > 400) {
            $(imageContainers).find('img').css('height', textboxHeight + "px");
        }
        else {
            $(imageContainers).find('img').css('height', minHeight + "px");
        }

        return imageHeight > 0 ? imageHeight : minHeight;
    }

    that.setEqualCaptionHeight = function (stage) {
        const captionContainer = $(stage).find(".image-caption");
        var highestCaption = 0;

        $(captionContainer).each(function (i, container) {
            if (highestCaption < $(container).outerHeight()) {
                highestCaption = $(container).outerHeight();
            }
        });

        $(captionContainer).css('height', highestCaption + "px");

        return highestCaption;
    }

    that.hasImageCaption = function (stage) {
        if ($(stage).find(".scEnabledChrome").length > 0) {
            return true;
        }

        if ($(stage).find(".content-stage-element.has-caption-data").length == 0) {
            $(stage).find("hr").remove();
            $(stage).find("figcaption").remove();

            return false;
        }

        return true;
    }

    that.setTabindexForNavigation = function (stage) {
        var prev = stage.querySelector('.prev');
        var next = stage.querySelector('.next');

        if (prev && next) {
            prev.setAttribute('tabindex', '0');
            next.setAttribute('tabindex', '0');
        }
    }

    that.debounce = function (func) {
        var timer;
        return function (event) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(func, 100, event);
        };
    }

    that.init = function () {
        $(document).find('.content-stage-container').each(function (i, stage) {
            const isEE = $(stage).find('.scEnabledChrome').length > 0;

            var timer = setInterval(function () {
                if ($(stage).find('.slick-initialized').length > 0 || isEE) {
                    if ($(stage).find(".pagination").length > 0 && !isEE) {
                        if ($(stage).find('.content-stage-element').length <= 1) {
                             $(stage).find(".pagination").remove();                                                     
                        }
                        else {
                            that.setTabindexForNavigation(stage);
                        }
                    }

                    that.hasImageCaption(stage);
                    that.setEqualContent($(stage));

                    $(stage).find('img.lazyload').on('lazyloaded', function () {
                        that.setEqualContent($(stage));
                    });

                    window.addEventListener('resize', function (e) {
                        that.setEqualContent($(stage));
                    });

                    window.addEventListener('orientationchange', function (e) {
                        that.setEqualContent($(stage));
                    });

                    clearInterval(timer);
                }
            }, 200);
        })
    };
};

window.am.contentStage.init();